import apiUrl from "../../../constants";
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate'
import VueAlertify from 'vue-alertify';
import {BasicSelect} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper'
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

export default {
  name: 'agentinscanreturn',
  components: {BasicSelect,VueElementLoading},
  props: [],
  mixins:[PageTracker],
  data () {
    return {
      agentid:'',
      process:'',
      awb:'',
      awbArray:[],
      obj:{},
      showTable: false,
      buttonLabel: 'InScan',
      returnArray:[],
      input:{
          "EntityType": "Agent"
      },
      shipmentDetails:[],
      isInScanReturnLoader: false,
      userDataKey : '',
    }
  },
  computed: {

  },
  watch: {
    awb: createClearInputWatcher('awb'),
  },
  async mounted () {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    //this.getSuperAgents();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.hubdetails = userdetail.hubdetails[0];
    this.mobilenumber = userdetail.mobilenumber;
    this.outsourcingid = userdetail.outsourcingid;
    this.userfullname = userdetail.username;

    let TrackerInfo = {
        projectname:"Last Mile",
        type:"Web",
        userid:this.localuserid,
        username:this.userfullname,
        meta: {
            "event":""
        }
    }
    let result  = this.PageTracker(TrackerInfo);

    const vm = this;
    $("#awb").keydown(function (event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == 13) {
        // $("#formSubmit").click();
        vm.validateForm('form-1');
        return false;
        event.stopPropagation();
      }
    });
  },
  methods: {
    ChangeLabelName(){
      this.buttonLabel = this.process == 'Shortage' ? 'Mark Shortage' : 'InScan';
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.isInScanReturnLoader = true;
          let shippingidsWithNextLine = this.awb.split("\n").map(String);
          let shippingidsWithComma = this.awb.split(",").map(String);
          if(shippingidsWithNextLine.length > 1) {
            $.each(shippingidsWithNextLine, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray.push(sid.trim());
              }
            })
          } else if(shippingidsWithComma.length >= 1){
            //console.log('CommaExecuted');
            $.each(shippingidsWithComma, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray.push(sid.trim());
              }
            })
          }

          let obj = {

            userfullname:this.userfullname,
            userphno:this.mobilenumber,
            process:this.process,
            awb:this.awbArray,
            createdby:'Agent'
          }
          console.log("obj",obj);
          axios({
              method: 'POST',
              'url':  apiUrl.api_url + 'AgentInscanReturn/InscanReturn',
              'data': obj,
              header:{
                'content-type': 'application/json'
              }
          }).then(result => {
            applySmartInputStyles(document.getElementById('awb'), result.data.lossCategorization);
            this.showTable = true;
            let arrayui=[];
            if(result.data.code === 200){
                this.returnArray = result.data.data;
                //this.$alertify.success(result.data.message);
            }else {
              if(typeof result.data.details !== 'undefined') {
                this.$alertify.error(result.data.details[0].message);
              } else{
                this.$alertify.error(result.data.message);
              }
            }
            this.isInScanReturnLoader = false;
        })
        .catch((httpException) => {
            this.$alertify.error("Something went wrong!!");
            console.error('exception is:::::::::', httpException)
            this.isInScanReturnLoader = false;
        });

        }
      }).catch(() => {
        console.log('errors exist', this.errors)
        this.isInScanReturnLoader = false;
      });
    },
    resetForm(){
      this.agent=''
      this.agentname=''
      this.handovermode=''
      this.vehicleno=''
      this.handoverpersonname=''
      this.awb=''
      this.process = ''
      this.awbArray=[]
      this.obj={}
      this.showTable= false
      this.returnArray=[],
      clearSmartInputStyles(document.getElementById('awb'));
      this.$validator.reset();
      this.errors.clear();
      this.isInScanReturnLoader = false;
    }
  }
}

Validator.extend('VerifyShippingidFormat', {
  getMessage: field => "maximum 10 Shipping ids you can enter",
  validate: value => {
      var shippingids = $("#awb").val();
      let shippingidNext=shippingids.split(/[\n]+/);
      let shippingidComma=shippingids.split(/[,]+/);
      if(shippingidNext.length>10 || shippingidComma.length > 10){
        return false;
      }else{
        return true;
      }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/agentinscanreturn/agentinscanreturn.component.js